<app-tablelayout [data]="logs" [filterItems]="filterOptions" [count]="count" [columnsToRemove]="removeColumn" [offset]="100" [allowExport]="true"
    (loadDataEvent)="loadDataEventHandler($event)"><app-tablelayout/>